import React from "react";
import { useAuth } from "../../Context/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import { getErrorMessage } from "../../Redux/Actions/errorMessage";

const Card = ({ data }) => {
  const { editLocalData, editLocalNumberData, deleteLocalData } = useAuth();

  const currentPage = useSelector((state) => state.activePage);

  const dispatch = useDispatch();

  function handleEdit(e, id) {
    const regex = /^(\d+(\.\d{0,5})?|\.?\d{1,2})$/;
    if (e.target.name.includes("costs") || e.target.name.includes("hours")) {
      if (e.target.value.match(regex)) {
        editLocalNumberData(e, id);
      } else {
        dispatch(
          getErrorMessage(
            `Felaktig inmatning i ${currentPage}, var god skriv in siffror!`
          )
        );
        const delayEditData = setTimeout(() => {
          dispatch(getErrorMessage(""));
        }, 5000);
        return () => clearTimeout(delayEditData);
      }
    } else {
      editLocalData(e, id);
    }
  }

  function handleDelete(id) {
    deleteLocalData(id);
  }

  //calculations

  function addPerYear(valueA, valueB, valueC) {
    let a = parseFloat(valueA);
    let b = parseFloat(valueB);
    let c = parseFloat(valueC);
    let result = a + b + c;
    if (isNaN(result) || !isFinite(result)) {
      return "";
    } else {
      // hide decimal if none
      if (result % 1 === 0) {
        return (result = parseInt(result, 10));
      } else {
        return (result = parseFloat(result, 10).toFixed(1));
      }
    }
  }
  return (
    <div className="container-input-mobile">
      <label className="label-mobile">Åtgärdsnamn</label>
      <input
        type="text"
        className="input-mobile-long"
        name="measureName"
        autoComplete="off"
        defaultValue={data.object.measureName}
        onChange={(e) => handleEdit(e, data.id)}
      />
      <div className="container-input-mobile-small-input">
        <div className="input-mobile-small-input-measures">
          <label className="label-mobile">Prioritet</label>
          <select
            className="input-mobile-dropdown"
            name="priority"
            autoComplete="off"
            defaultValue={data.object.priority}
            onChange={(e) => handleEdit(e, data.id)}
          >
            {/*<option selected>{priority}</option>*/}
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
          </select>
        </div>
        <div className="input-mobile-small-input-measures">
          <label className="label-mobile">Ansvarig</label>
          <input
            type="text"
            className="input-mobile"
            name="responsible"
            autoComplete="off"
            defaultValue={data.object.responsible}
            onChange={(e) => handleEdit(e, data.id)}
          />
        </div>
      </div>
      <label className="label-mobile">Startdatum</label>
      <input
        className="input-mobile-date"
        type="date"
        name="startdate"
        autoComplete="off"
        defaultValue={data.object.startdate}
        onChange={(e) => handleEdit(e, data.id)}
      />

      <label className="label-mobile">Klartdatum</label>
      <input
        type="date"
        className="input-mobile-date"
        name="enddate"
        autoComplete="off"
        defaultValue={data.object.enddate}
        onChange={(e) => handleEdit(e, data.id)}
      />

      <label className="label-mobile">Planerade åtgärdstimmar</label>
      <div className="container-input-mobile-small-input">
        <div className="input-mobile-small-input-measures">
          <label className="label-mobile">År 1</label>
          <input
            type="text"
            className="input-mobile-small"
            name="hours1"
            autoComplete="off"
            defaultValue={data.object.hours1 === 0 ? "" : data.object.hours1}
            onChange={(e) => handleEdit(e, data.id)}
          />
        </div>
        <div className="input-mobile-small-input-measures">
          <label className="label-mobile">År 2</label>
          <input
            type="text"
            className="input-mobile-small"
            name="hours2"
            autoComplete="off"
            defaultValue={data.object.hours2 === 0 ? "" : data.object.hours2}
            onChange={(e) => handleEdit(e, data.id)}
          />
        </div>
        <div className="input-mobile-small-input-measures">
          <label className="label-mobile">År 3</label>
          <input
            type="text"
            className="input-mobile-small"
            name="hours3"
            autoComplete="off"
            defaultValue={data.object.hours3 === 0 ? "" : data.object.hours3}
            onChange={(e) => handleEdit(e, data.id)}
          />
        </div>
      </div>
      <label className="label-mobile">Totalt Planerade åtgärdstimmar</label>
      <output className="input-mobile-long" name="hours-total">
        {addPerYear(data.object.hours1, data.object.hours2, data.object.hours3)}
      </output>

      <label className="label-mobile">Planerat finansieringsbehov</label>
      <div className="container-input-mobile-small-input">
        <div className="input-mobile-small-input-measures">
      <label className="label-mobile">År 1</label>
      <input
        type="text"
        className="input-mobile-small"
        name="costs1"
        autoComplete="off"
        defaultValue={data.object.costs1 === 0 ? "" : data.object.costs1}
        onChange={(e) => handleEdit(e, data.id)}
      />
</div>
        <div className="input-mobile-small-input-measures">
      <label className="label-mobile">År 2</label>
      <input
        type="text"
        className="input-mobile-small"
        name="costs2"
        autoComplete="off"
        defaultValue={data.object.costs2 === 0 ? "" : data.object.costs2}
        onChange={(e) => handleEdit(e, data.id)}
      />
</div>
        <div className="input-mobile-small-input-measures">
      <label className="label-mobile">År 3</label>
      <input
        type="text"
        className="input-mobile-small"
        name="costs3"
        autoComplete="off"
        defaultValue={data.object.costs3 === 0 ? "" : data.object.costs3}
        onChange={(e) => handleEdit(e, data.id)}
      />
</div>
      </div>
      <label className="label-mobile">Totalt Planerat finansieringsbehov</label>
      <output className="input-mobile-long" name="costs-total">
        {addPerYear(data.object.costs1, data.object.costs2, data.object.costs3)}
      </output>
      <button className="button-delete" onClick={() => handleDelete(data.id)}>
        Ta bort vara/produkt
      </button>
    </div>
  );
};
export default Card;
